<template>
  <div class="box-main" v-show="show">
    <transition name="opacity">
      <div class="cover" v-show="show"></div>
    </transition>
    <transition name="alert">
      <div class="box" v-show="show">
        <div class="title"><span>请选择城市</span><i class="close iconfont iconx" @click="$emit('close');"></i></div>
        <div class="option">
          <div
            v-for="(item, index) in optionText"
            :key="index"
            :class="['option-item', index === option ? 'active' : '']"
            @click="selectOption(index, item)">{{item}}</div>
        </div>
        <div class="content city-box-content-scroll">
          <div
            class="city-menu"
            v-for="(item, index) in cities"
            :key="index"
            :ref="'city' + item.group_name">
            <div class="city-menu-before">{{item.group_name === '热门城市' ? '' : item.group_name}}</div>
            <div class="city-menu-content">
              <div
                class="city-menu-item"
                :class="[
                  (
                    (!queryData.city_names && opt.city_name === '全国')
                    || queryData.city_names === opt.city_name
                  )
                  ? 'active' : ''
                ]"
                v-for="(opt, num) in item.part_cities"
                :key="num"
                @click="$emit('select', opt)">{{opt.city_name}}</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import api from '@/api';
const getPositionTop = (node) => { // 获取元素到顶部距离-通用方法
  var top = node.offsetTop;
  var parent = node.offsetParent;
  while(parent != null) {
      top += parent.offsetTop;
      parent = parent.offsetParent;
  }
  return top; // 所有的父元素top和
};
export default {
  name: 'City',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    queryData: {}
  },
  data() {
    return {
      optionText: ['热门城市', 'ABCDE', 'FGHJ', 'KLMN', 'PQRST', 'WXYZ'],
      option: 0,
      cities: []
    };
  },
  mounted() {
    this.getCity();
    document.querySelector('.city-box-content-scroll').addEventListener('scroll', (e) => {this.scrollEvent(e)})
  },
  methods: {
    selectOption(index, text) {
      this.option = index;
      let ref = null;
      for (let i = 0; ; i++) {
        let name = '';
        if (text === '热门城市') {
          ref = this.$refs['city' + text];
          break;
        }
        else {
          ref = this.$refs['city' + text.split('')[i]];
        }
        if (ref) break;
      }
      let y = ref[0].offsetTop - ref[0].parentNode.offsetTop;
      document.querySelector('.city-box-content-scroll').scrollTo({ behavior: 'smooth', top: y - 20 });
      // console.log(ref[0], ref[0].parentNode, ref[0].offsetTop - ref[0].parentNode.offsetTop);
    },
    scrollEvent($event) {
      clearTimeout(this.run);
      this.run = setTimeout(() => {
        let optionText = this.optionText;
        let arr = [];
        for (let i = 0; i < optionText.length; i++) {
          let ref = null;
          if (optionText[i] === '热门城市') {
            ref = this.$refs['city' + optionText[i]]
          }
          else {
            ref = this.$refs['city' + optionText[i].split('')[0]]
          }
          let y = ref[0].offsetTop - ref[0].parentNode.offsetTop - $event.target.scrollTop;
          if (y <= 50) {
            this.option = i;
          }
        }
      }, 100);
    },
    // 获取城市
    async getCity() {
      let res1 = await api.recruit.toObtainCityNew({nums:0,job_count:10});
      let city = []
      Object.keys(res1.data).forEach((key,index)=>{
        let obj ={}
        obj.group_name = key=='hot_cities'?'热门城市':key;
        obj.part_cities = res1.data[key].map(item=>{
          item.id= item.city_id
          return item
        })
        city.push(obj)
      })
      let cities = city || [];
      let hot_cities = res1.data.hot_cities || [];
      hot_cities.unshift({city_name: '全国', id: 0});
      cities[0] = {group_name: '热门城市', part_cities: hot_cities};
      this.cities = cities;
    },
  },
}
</script>
<style lang="scss" scoped>
.box-main {
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  .cover {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11;
  }
  .box {
    width: 600px;
    height: 400px;
    background: #fff;
    border-radius: 4px;
    position: fixed;
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
    margin: auto;
    z-index: 12;
    .title {
      padding: 0 24px;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        font-size: 16px;
        color: #404040;
      }
      .iconfont {
        font-size: 18px;
        color: #BCBCBC;
        font-weight: 600;
        cursor: pointer;
      }
    }
    .option {
      width: 100%;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: rgba(255, 102, 68, .04);
      padding: 0 24px;
      .option-item {
        height: 100%;
        line-height: 34px;
        cursor: pointer;
        font-size: 14px;
        color: #606060;
        position: relative;
        &.active {
          color: #FF6644;
          &::after {
            content: "";
            display: block;
            width: 32px;
            height: 2px;
            background: #FF6644;
            position: absolute;
            left: 50%;
            bottom: 0;
            margin-left: -16px;
          }
        }
      }
    }
    .content {
      height: 306px;
      overflow-y: auto;
    }
    .city-menu {
      display: flex;
      &:first-child {
        margin-top: 24px;
      }
      .city-menu-before {
        width: 64px;
        text-align: center;
        font-size: 14px;
        color: #FF6644;
        flex: none;
      }
      .city-menu-content {
        display: flex;
        flex-wrap: wrap;
        .city-menu-item {
          display: block;
          cursor: pointer;
          width: 100px;
          font-size: 14px;
          color: #404040;
          margin-bottom: 24px;
          &.active,
          &:hover {
            color: #FF6644;
          }
        }
      }
    }
  }
}
</style>